module.exports = __webpack_public_path__ + "static/media/blog8.62086732.webp";